import './vendor';
import 'script-loader!../../node_modules/slick-carousel/slick/slick.min.js';
//import 'script-loader!../../www/js/vendor/OwlCarousel2-2.2.1/dist/owl.carousel.min.js';

$(function() {
    /*
     * Replace all SVG images with inline SVG
     */
        $('.svg-inline').each(function(){
            var $img = $(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                } else {
                    $svg.removeAttr('id');
                }                
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        }); 
        
    $("#hp-carousel").slick({
        autoplay: true,        
        infinite: true,            
        arrows: false,
        dots: false,
        autoplaySpeed: 5000,
        speed: 1500,
        fade: true,
        cssEase: 'linear'        
    });        
    
    $(".scroll-to").bind('click', function() {
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - $('.header').height()
        }, 500);
        
        return false;
    });
    
    $('.open-popup-link').magnificPopup({
        tClose: 'Zavřít (Esc)',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
        type:'inline',
        removalDelay: 300,
        mainClass: 'mfp-fade',
        fixedContentPos: false,
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });     
    
    let onScroll = null;
    (onScroll = function() {
        const sc = $(window).scrollTop()
        if (sc > 200) {
            $("#header-scroll").addClass("small")
        } else {
            $("#header-scroll").removeClass("small")
        }
    })();
    
    $(window).bind('scroll', function () { onScroll() });    
});





// WEBPACK FOOTER //
// ./www/js/desktop.js